<template>
  <Teleport to="body">
    <!-- Default toasts: stacked in the top-right corner. -->
    <div class="fixed top-4 right-4 z-[1000] flex flex-col gap-2 pointer-events-none">
      <TransitionGroup name="toast">
        <ToastItem v-for="toast in cornerToasts" :key="toast.id" :toast="toast" @dismiss="dismissToast" />
      </TransitionGroup>
    </div>

    <!-- position: 'center' — overlaid in the middle of the viewport. The
         container ignores pointer events so it never blocks the page; each
         toast re-enables them for its own close button. -->
    <div class="fixed inset-0 z-[1000] flex flex-col items-center justify-center gap-2 pointer-events-none">
      <TransitionGroup name="toast-center">
        <ToastItem v-for="toast in centerToasts" :key="toast.id" :toast="toast" @dismiss="dismissToast" />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from '@/composables/useToast';
import ToastItem from './ToastItem.vue';

const { toasts, dismissToast } = useToast();

const cornerToasts = computed(() => toasts.value.filter((toast) => toast.position !== 'center'));
const centerToasts = computed(() => toasts.value.filter((toast) => toast.position === 'center'));
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* Centered toasts fade and scale rather than slide in from the edge. */
.toast-center-enter-active,
.toast-center-leave-active {
  transition: all 0.25s ease;
}
.toast-center-enter-from,
.toast-center-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
